"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RemoveModalContentCms = void 0;
var RemoveModalContentCms = /** @class */ (function () {
    function RemoveModalContentCms() {
        this.bundleRemoveHeader = 'By removing this service, you may no longer be' +
            ' eligible for special bundle promotions such as';
        this.bundleRemoveDiscountMsg = 'Select monthly discounts on bundled services';
        this.bundleRemovePromoMsg = 'Select promotional reward cards';
        this.cancelButtonLabel = 'No';
        this.removeButtonLabel = 'Yes';
        this.removeModalBody = 'Sure you want to remove this?';
        this.removeModalTitle = 'Remove from cart';
        this.removeMessageBodyLabel = 'We\'ll also remove your accessories.' +
            ' To qualify for special promotions, your bundle must include TV.';
        this.removeMessageHeaderLabel = 'Heads up:';
    }
    return RemoveModalContentCms;
}());
exports.RemoveModalContentCms = RemoveModalContentCms;
//# sourceMappingURL=RemoveModalContent.cms.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/shared/RemoveModalContent/RemoveModalContent.cms.js
// module id = 1428
// module chunks = 8